'use strict';

var SplashPageDirective = function SplashPageDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/splash-page.html'),
    controller: 'SplashPageController',
    scope: {
      wizardShown: '='
    },
    link: function link(scope, element) {
      scope.showPrepareItemsModal = function (wizard) {
        scope.setChosenWizard(wizard);
        element.find('#prepare-items-modal').modal('show');
      };
    }
  };
};
SplashPageDirective.$inject = [];
module.exports = SplashPageDirective;